import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import colors from '../../../../assets/theme/base/colors';

export const stepFieldWidth = 420;

interface IProps {
    stepNumber: number;
    title: string;
    description?: React.ReactNode;
    pending?: boolean;
    children: React.ReactNode;
}

export const ImportStep: React.FC<IProps> = ({stepNumber, title, description, pending, children}) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: '30px 1fr',
                columnGap: 2.5,
                py: 3,
                borderTop: `1px solid ${colors.ui.border}`,
                '&:first-of-type': {borderTop: 'none', pt: 0}
            }}>
            <Box
                sx={{
                    width: 28,
                    height: 28,
                    mt: '2px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: pending ? colors.transparent.main : colors.primary.main,
                    border: pending ? `1.5px dashed ${colors.ui.border}` : 'none'
                }}>
                <Typography
                    variant="caption"
                    fontWeight="bold"
                    sx={{color: pending ? colors.ui.tertiaryText : colors.white.main}}>
                    {stepNumber}
                </Typography>
            </Box>

            <Box sx={{minWidth: 0}}>
                <Typography
                    variant="body2"
                    component="h2"
                    fontWeight="bold"
                    sx={{color: pending ? colors.ui.tertiaryText : colors.dark.main}}>
                    {title}
                </Typography>
                {description &&
                    <Typography variant="caption" color="secondary" component="div">
                        {description}
                    </Typography>
                }
                <Stack spacing={2} sx={{mt: 2}}>
                    {children}
                </Stack>
            </Box>
        </Box>
    );
};
